import { CookieService } from "../services";
import axios from "axios";

export const AxiosGraphQlAction = (variables: any, query: string) => {
    const jwt = CookieService.readCookie("piap_jwt_token");
    const URL = process.env.REACT_APP_API_HOST ?? "";
    return axios
        .post(
            URL,
            {
                query,
                variables,
            },
            {
                headers: { Authorization: `Bearer ${jwt}` },
            }
        )
        .then((response) => {
            return response;
        })
        .catch((err) => {
            throw err;
        });
};
